export const SORT_OPTIONS = [
  { value: 'lastContentUpdatedAt,DESC', label: 'Recently updated' },
  { value: 'createdAt,DESC', label: 'Newest first' },
  { value: 'rankScore,DESC', label: 'Trending' },
  { value: 'averageRating,DESC', label: 'Rating (high → low)' },
  { value: 'viewCount,DESC', label: 'Views (high → low)' },
  { value: 'bookmarkCount,DESC', label: 'Most bookmarked' },
  { value: 'title,ASC', label: 'Title (A → Z)' },
  { value: 'title,DESC', label: 'Title (Z → A)' },
];

export const COMPLETION_OPTIONS = [
  { value: 'any', label: 'Any status' },
  { value: 'completed', label: 'Completed' },
  { value: 'ongoing', label: 'Ongoing' },
];

export const ORIGIN_OPTIONS = [
  { value: '', label: 'Any origin' },
  { value: 'Afrikaans', label: 'Afrikaans' },
  { value: 'Albanian', label: 'Albanian' },
  { value: 'American', label: 'American' },
  { value: 'Amharic', label: 'Amharic' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Argentine', label: 'Argentine' },
  { value: 'Armenian', label: 'Armenian' },
  { value: 'Australian', label: 'Australian' },
  { value: 'Austrian', label: 'Austrian' },
  { value: 'Bangladeshi', label: 'Bangladeshi' },
  { value: 'Belarusian', label: 'Belarusian' },
  { value: 'Belgian', label: 'Belgian' },
  { value: 'Bosnian', label: 'Bosnian' },
  { value: 'Brazilian', label: 'Brazilian' },
  { value: 'British', label: 'British' },
  { value: 'Bulgarian', label: 'Bulgarian' },
  { value: 'Burmese', label: 'Burmese' },
  { value: 'Cambodian', label: 'Cambodian' },
  { value: 'Canadian', label: 'Canadian' },
  { value: 'Catalan', label: 'Catalan' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Croatian', label: 'Croatian' },
  { value: 'Cypriot', label: 'Cypriot' },
  { value: 'Czech', label: 'Czech' },
  { value: 'Danish', label: 'Danish' },
  { value: 'Dutch', label: 'Dutch' },
  { value: 'English', label: 'English' },
  { value: 'Estonian', label: 'Estonian' },
  { value: 'Faroese', label: 'Faroese' },
  { value: 'Filipino', label: 'Filipino' },
  { value: 'Finnish', label: 'Finnish' },
  { value: 'French', label: 'French' },
  { value: 'Georgian', label: 'Georgian' },
  { value: 'German', label: 'German' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Hebrew', label: 'Hebrew' },
  { value: 'Hungarian', label: 'Hungarian' },
  { value: 'Icelandic', label: 'Icelandic' },
  { value: 'Indian', label: 'Indian' },
  { value: 'Indonesian', label: 'Indonesian' },
  { value: 'Irish', label: 'Irish' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Kazakh', label: 'Kazakh' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Lao', label: 'Lao' },
  { value: 'Latvian', label: 'Latvian' },
  { value: 'Liechtensteiner', label: 'Liechtensteiner' },
  { value: 'Lithuanian', label: 'Lithuanian' },
  { value: 'Luxembourgish', label: 'Luxembourgish' },
  { value: 'Macedonian', label: 'Macedonian' },
  { value: 'Malaysian', label: 'Malaysian' },
  { value: 'Maltese', label: 'Maltese' },
  { value: 'Mexican', label: 'Mexican' },
  { value: 'Moldovan', label: 'Moldovan' },
  { value: 'Mongolian', label: 'Mongolian' },
  { value: 'Montenegrin', label: 'Montenegrin' },
  { value: 'Nepali', label: 'Nepali' },
  { value: 'New Zealander', label: 'New Zealander' },
  { value: 'Norwegian', label: 'Norwegian' },
  { value: 'Pakistani', label: 'Pakistani' },
  { value: 'Persian', label: 'Persian' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Romanian', label: 'Romanian' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Scottish', label: 'Scottish' },
  { value: 'Serbian', label: 'Serbian' },
  { value: 'Singaporean', label: 'Singaporean' },
  { value: 'Slovak', label: 'Slovak' },
  { value: 'Slovenian', label: 'Slovenian' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Sri Lankan', label: 'Sri Lankan' },
  { value: 'Swahili', label: 'Swahili' },
  { value: 'Swedish', label: 'Swedish' },
  { value: 'Swiss', label: 'Swiss' },
  { value: 'Thai', label: 'Thai' },
  { value: 'Turkish', label: 'Turkish' },
  { value: 'Ukrainian', label: 'Ukrainian' },
  { value: 'Uzbek', label: 'Uzbek' },
  { value: 'Vietnamese', label: 'Vietnamese' },
  { value: 'Welsh', label: 'Welsh' },
  { value: 'Yoruba', label: 'Yoruba' },
];

/** Look up the human-readable label for a sort value */
export const getSortLabel = (sortValue) => {
  const option = SORT_OPTIONS.find((o) => o.value === sortValue);
  return option ? option.label : sortValue;
};
